import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import SpotifyIcon from './assets/icons/SpotifyIcon';
import AppleIcon from '@mui/icons-material/Apple';

const SOCIAL_LINKS = [
  {
    href: 'https://www.instagram.com/pushforward.online',
    label: 'Instagram',
    icon: <InstagramIcon />,
  },
  {
    href: 'https://www.facebook.com/profile.php?id=61558005543750',
    label: 'Facebook',
    icon: <FacebookIcon />,
  },
  {
    href: 'https://www.youtube.com/channel/UCJrljr8O4kkTqWDBmElCPCw',
    label: 'YouTube',
    icon: <YouTubeIcon />,
  },
  {
    href: 'https://open.spotify.com/artist/4WQRHx9X2yrzDSTkbKUvTE?si=edPFNsoPQwmAmXmvyW1QqA',
    label: 'Spotify',
    icon: <SpotifyIcon />,
  },
  {
    href: 'https://music.apple.com/us/artist/push-forward/1746204663',
    label: 'Apple Music',
    icon: <AppleIcon />,
  },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box className='footer' component='footer'>
      <Box className='footerIcons'>
        {SOCIAL_LINKS.map(({ href, label, icon }) => (
          <Link
            key={label}
            href={href}
            target='_blank'
            rel='noreferrer'
            aria-label={label}
            className='footerIcon'
            underline='none'
          >
            {icon}
          </Link>
        ))}
      </Box>
      <Box className='footerCopy'>
        © {year} Push Forward — All rights reserved
      </Box>
    </Box>
  );
}

export default Footer;
